import { ComponentType } from 'react';

import { mergeClasses } from '@/utils';

import { Loading02Icon } from '@/assets/icons';
import { SvgIcon, VerticalBaseModal } from '@/components/common';

interface IConfirmationDialog {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm?: () => void;
  title: string;
  subtitle: string;
  message?: string;
  okButtonText?: string;
  cancelButtonText?: string;
  variant?: 'green' | 'red';
  isConfirming?: boolean;
  icon: ComponentType<{ className?: string }>;
  closeOnEscape?: boolean;
}

const ConfirmationDialog = ({
  open,
  onOpenChange,
  onConfirm,
  title,
  subtitle,
  message,
  okButtonText,
  cancelButtonText,
  variant,
  isConfirming,
  icon,
  closeOnEscape,
}: IConfirmationDialog) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'green':
        return 'bg-green-lightest border border-green-lighter text-green-base';
      case 'red':
        return 'bg-red-lightest border border-red-lighter text-red-base';
    }
  };

  return (
    <VerticalBaseModal
      open={open}
      onOpen={onOpenChange}
      icon={
        <div
          className={mergeClasses(
            'size-[70px] rounded-full flex flex-row justify-center items-center',
            getVariantStyles(),
          )}
        >
          <SvgIcon component={icon} className="size-9" />
        </div>
      }
      title={title}
      okButtonLabel={
        isConfirming ? (
          <Loading02Icon className="size-6 text-white animate-[spin_2s_linear_infinite]" />
        ) : (
          okButtonText || 'Confirm'
        )
      }
      okButtonClassName={mergeClasses(
        'bg-primary-base',
        isConfirming && 'cursor-not-allowed pointer-events-none',
      )}
      onOk={() => {
        onConfirm?.();
      }}
      cancelButtonText={cancelButtonText || 'Cancel'}
      onCancel={() => onOpenChange(false)}
      isCancelButtonDisabled={isConfirming}
      contentClassName="!w-[400px]"
      closeOnEscape={closeOnEscape}
      subtitle={
        subtitle && <div className="font-medium text-body-sm text-neutral-7">{subtitle}</div>
      }
    >
      {message && <div className="font-medium text-body-sm text-neutral-9">{message}</div>}
    </VerticalBaseModal>
  );
};

export default ConfirmationDialog;
